import React from "react";
import { Link } from "react-router-dom";
import "./RightElements.css";

const FooterElements = () => (
  <div className="footer-elements">
    <div className="footer-links-row">
      <Link to="/about">Despre</Link>
      <Link to="/check-certification">Certificari</Link>
       <Link to="/ajutor">Afiliere</Link>
      <Link to="/blog">Blog</Link>
      <Link to="/ajutor">Contact</Link>
      <Link to="/politica">Confidentialitate</Link>
      <Link to="/termeni">Termeni</Link>
    </div>
  </div>
);

export default FooterElements;
